<template>
      <div>
        hello
      </div>  
</template>

<script>


export default {
     name:'search',
     data(){
        return{
            
        }
    },
    mounted(){
        this.getSearch()
    },
    methods:{
        getSearch(){
             let pram = {
                channels: "[\"01823EEA10DF7500DE7B93FB84B477F6\"]",
                // channels: JSON.stringify(),
                filter: JSON.stringify({ searchKeys: '高校' }),
                pageInfo: JSON.stringify({
                    'pageNum': 1,
                    'pageSize': 10
                })
            }
            GMS.$http.post('/portal/cms/view/contents', pram, {
            }).then(res => {
                if (res.status == 200) {
                    // this.ListB = res.data.bean
                    // this.tital = res.data.total
                    console.log(res)
                }
            }).catch(error => {
                // this.$Message.error("获取数据异常，请联系管理员");
            })
        }
    }
     
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/inside/search.vue